import { useFormContext } from "react-hook-form"
import { useUserDetails } from "../store"

function PersonalDetails() {
  const { userDetails } = useUserDetails()
  const { setEditingUserDetails } = useFormContext()

  const { firstName, lastName, address, zip, city } = userDetails

  if (!firstName && !lastName && !address && !zip && !city) {
    return null
  }

  return (
    <div className="w-full px-3 mb-3 lg:mb-6">
      <p>
        <span className="font-bold">För och efternamn: </span>
        {firstName} {lastName}
      </p>
      <p>
        <span className="font-bold">Gatuadress: </span>
        {address}
      </p>
      <p>
        <span className="font-bold">Postnummer och ort: </span>
        {zip} {city}
      </p>
      <button
        className="mt-2 text-sm underline cursor-pointer"
        type="button"
        aria-label="Redigera adress"
        onClick={() => setEditingUserDetails(true)}>
        Redigera adress
      </button>
    </div>
  )
}

export default PersonalDetails
